var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { "show-footer": false, "show-title": false },
      on: { cancel: _vm.close },
    },
    [
      _c("div", { staticClass: "limited-modal" }, [
        _c("div", { staticClass: "limited-modal-title" }, [
          _c("span", { staticClass: "material-icons alert-icon" }, [
            _vm._v("notification_important"),
          ]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("billing.youAreCurrentlyLimited")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "limited-modal-description" }, [
          _c("div", { staticClass: "limited-modal-description-text" }, [
            _vm._v(
              "\n                Tekrar erişim sağlamak için lütfen aşağıdaki koşulları sağlayınız.\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "limited-modal-description-content" }, [
            _vm.shouldSelectPlan.supsisPackage
              ? _c("div", { staticClass: "information-detail" }, [
                  _c("div", { staticClass: "information-detail-text" }, [
                    _vm._v(
                      "\n                        - " +
                        _vm._s(_vm.$t("report.total")) +
                        " "
                    ),
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.shouldSelectPlan.details.current.users)
                      ),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("billing.youHaveOneRepresentative")) +
                        "\n                        "
                    ),
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.shouldSelectPlan.details.current.users -
                            _vm.shouldSelectPlan.details.limit
                              .currentSupsisAgentCount
                        )
                      ),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("billing.deactivateOrDeleteYourPiece")) +
                        "\n                    "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.shouldSelectPlan.whatsappQr
              ? _c("div", { staticClass: "information-detail" }, [
                  _c("div", { staticClass: "information-detail-text" }, [
                    _vm._v(
                      "\n                        - " +
                        _vm._s(_vm.$t("report.total")) +
                        " "
                    ),
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.shouldSelectPlan.details.current.whatsappQr)
                      ),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("billing.youHaveOneWhatsappQRChannel")) +
                        "\n                        "
                    ),
                    _c("b", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.shouldSelectPlan.details.current.whatsappQr -
                              _vm.shouldSelectPlan.details.limit
                                .currentWhatsappPlanCount
                          )
                      ),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("billing.deleteYourWhatsAppQR")) +
                        "\n                    "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.shouldSelectPlan.whatsappBusiness
              ? _c("div", { staticClass: "information-detail" }, [
                  _c("div", { staticClass: "information-detail-text" }, [
                    _vm._v(
                      "\n                        - " +
                        _vm._s(_vm.$t("report.total")) +
                        "\n                        "
                    ),
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.shouldSelectPlan.details.current
                            .whatsappBusinessChannels
                        )
                      ),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("billing.youHaveAWhatsappBusiness")) +
                        "\n                        "
                    ),
                    _c("b", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.shouldSelectPlan.details.current
                              .whatsappBusinessChannels -
                              _vm.shouldSelectPlan.details.limit
                                .currentWhatsappBusinessChannelCount
                          )
                      ),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("billing.deleteYourWhatsapp")) +
                        "\n                    "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.shouldSelectPlan.instagram
              ? _c("div", { staticClass: "information-detail" }, [
                  _c("div", { staticClass: "information-detail-text" }, [
                    _vm._v(
                      "\n                        - " +
                        _vm._s(_vm.$t("report.total")) +
                        " "
                    ),
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.shouldSelectPlan.details.current.instagram)
                      ),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("billing.youHaveAnInstagram")) +
                        "\n                        "
                    ),
                    _c("b", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.shouldSelectPlan.details.current.instagram -
                              _vm.shouldSelectPlan.details.limit.instagram
                          )
                      ),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("billing.deleteYourInstagram")) +
                        "\n                    "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.shouldSelectPlan.messenger
              ? _c("div", { staticClass: "information-detail" }, [
                  _c("div", { staticClass: "information-detail-text" }, [
                    _vm._v(
                      "\n                        - " +
                        _vm._s(_vm.$t("report.total")) +
                        " "
                    ),
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.shouldSelectPlan.details.current.messenger)
                      ),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("billing.youHaveAMessenger")) +
                        "\n                        "
                    ),
                    _c("b", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.shouldSelectPlan.details.current.messenger -
                              _vm.shouldSelectPlan.details.limit.messenger
                          )
                      ),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("billing.deleteYourMessenger")) +
                        "\n                    "
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "limited-modal-footer" },
          [
            _c(
              "SupsisButton",
              { attrs: { primary: "" }, on: { click: _vm.close } },
              [_vm._v("Kapat")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }